/**
 * Created by intellicar-rinas on 20/3/18.
 */


/*
*
*   Marker Config
*
* */

const factor = 1.1;
let SCALE = 12;

const checkZoomLevel =(min, max, zoomLevel)=> {
    return (zoomLevel >= min && zoomLevel <= max);
};

export const getScaleFromZoomLevel =zoomLevel=> {
    if (checkZoomLevel(1, 7, zoomLevel)) {
        SCALE = 12 * factor;
    } else if (checkZoomLevel(8, 9, zoomLevel)) {
        SCALE = 16 * factor;
    } else if (checkZoomLevel(10, 11, zoomLevel)) {
        SCALE = 20 * factor;
    } else if (checkZoomLevel(12, 14, zoomLevel)) {
        SCALE = 24 * factor;
    } else {
        SCALE = 32 * factor;
    }
    return SCALE;
};